module.exports = __webpack_public_path__ + "img/51.counter_men.2a4e99f3.svg";